// Flat icon grid used when no project type is selected
import React from "react";

import iconHome from "../../assets/icons/home.svg";
import iconPlay from "../../assets/icons/play-circle.svg";
import iconPencil from "../../assets/icons/pencil.svg";
import iconUpload from "../../assets/icons/upload.svg";
import iconSliders from "../../assets/icons/sliders.svg";
import iconSparkles from "../../assets/icons/sparkles.svg";

const ICONS = [iconPlay, iconPencil, iconUpload, iconSliders, iconSparkles, iconHome];

function buildTiles(count = 12) {
  return Array.from({ length: count }).map((_, i) => ({
    id: `t-${i + 1}`,
    icon: ICONS[i % ICONS.length],
    label: `Chapter ${i + 1}`,
  }));
}

export default function FlatIconGrid({ columns = 4, count = 12, tiles: tilesProp, videoChapterIds, thumbByChapter, onSelect }) {
  const tiles = Array.isArray(tilesProp) && tilesProp.length ? tilesProp : buildTiles(count);
  const gridStyle = {
    gridTemplateColumns: `repeat(${Math.max(1, columns)}, minmax(120px, 1fr))`,
  };

  return (
    <div className="lrp-flat-grid" style={gridStyle} role="grid" aria-label="Default layout preview">
      {tiles.map((t, idx) => {
        const hasVideo = videoChapterIds && videoChapterIds.has?.(t.id);
        const thumbUrl = (thumbByChapter && (thumbByChapter.get?.(t.id) || thumbByChapter[t.id])) || null;
        return (
        <button
          key={t.id}
          type="button"
          className={`lrp-icon-tile ${hasVideo ? 'has-video' : ''}`}
          onClick={() => onSelect && onSelect(t)}
          aria-label={t.label}
          role="gridcell"
        >
          <div className="lrp-thumb" aria-hidden="true">
            <div
              className={`lrp-thumb-image ${thumbUrl ? 'has-thumb' : ''}`}
              data-variant={(idx % 6) + 1}
              style={thumbUrl ? { backgroundImage: `url(${thumbUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' } : undefined}
            />
          </div>
          <div className="lrp-icon-caption">
            <span className="lrp-caption-title">{t.label}</span>
            {t.readingTime ? (
              <span className="lrp-caption-meta"> • {t.readingTime}</span>
            ) : null}
          </div>
          <div className="lrp-tile-footer">
            <button
              type="button"
              className="lrp-tile-btn"
              onClick={(e) => {
                e.stopPropagation();
                const hasVideoInner = videoChapterIds && videoChapterIds.has?.(t.id);
                onSelect && onSelect({ ...t, action: hasVideoInner ? 're-read' : 'live-read' });
              }}
            >
              {hasVideo ? (
                <>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{marginRight:6, verticalAlign:'text-bottom'}} aria-hidden>
                    <path d="M8 5v14l11-7-11-7z"></path>
                  </svg>
                  Re‑read
                </>
              ) : (
                'Live read'
              )}
            </button>
          </div>
        </button>
        );
      })}
    </div>
  );
}
